<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow alignHorizontal="center" alignVertical="center">
        <CCol col="1">
          <CRow alignHorizontal="end">
            <div
              class="containerIconLeft"
              @click="funcRoute(content.navigate.previous.action)"
              v-if="!mode.pretestMode && !mode.posttestMode && !mode.testmode"
            >
              <font-awesome-icon
                class="IconLeft"
                icon="chevron-left"
              ></font-awesome-icon>
            </div>
          </CRow>
        </CCol>
        <CCol col="10">
          <CardSelection
            :cardContent="content"
            :Type="Type"
            :cardType="cardType"
            @setIsNextButtonActive="setIsNextButtonActive"
            @selectedAns="selectedAns"
            :soundOBJ="soundObject"
            :AnswerType="AnswerType"
            :initialAnswer="data"
            :AnswerChoice="answer"
          />
          <CModal
            :title="ModalData.title"
            centered
            :color="ModalData.color"
            :show.sync="ShowAnswerModal"
            :closeOnBackdrop="false"
            class="CmodalShowAnswer"
          >
            <template v-if="ModalData.color === 'danger'">
              <h2>{{ ModalData.data.split('#')[0] }}</h2>
              <h2 class="fontChinese">{{ ModalData.data.split('#')[1] }}</h2>
            </template>
            <template v-else
              ><h2>{{ ModalData.data.split('#')[0] }}</h2></template
            >
            <br />
            <CRow align-vertical="end" align-horizontal="center">
              <CButton
                @click="ModalRoute()"
                color="success"
                shape="pill"
                class="ml-2 mr-2 mt-5"
                >Next</CButton
              >
            </CRow>
          </CModal>
        </CCol>
        <CCol col="1">
          <CRow>
            <div class="containerIconRight" @click="beforeSet()">
              <font-awesome-icon
                class="IconRight"
                icon="chevron-right"
              ></font-awesome-icon>
            </div>
          </CRow>
        </CCol>
      </CRow>
    </template>
  </div>
</template>

<script>
import '../../../assets/scss/_chineseStyle.scss';
import '../../../assets/scss/_chineseIcon.scss';
import '../../../assets/scss/_chineseModalCustom.scss';
import CardPopupImg from './components/CardPopupImg.vue';
import PopupIntroCModal from './components/PopupIntroCModal.vue';
import CardSelection from './components/CardSelection.vue';
import {mapGetters} from 'vuex';
import LoadingMDL from '../../../components/loading/LoadingMDL';
import preTestTemplate from '../../../assets/json/pre_test_chn.json';
import testTemplate from '../../../assets/json/test_IAM05';

export default {
  components: {CardSelection, CardPopupImg, PopupIntroCModal, LoadingMDL},
  name: 'IAM05',
  data() {
    return {
      isNextButtonActive: false,
      content: {},
      CheckWidth: window.innerWidth,
      lang: this.$store.getters['language/getLanguage'],
      baseUrl: process.env.VUE_APP_URL_SOUND,
      Type: '',
      AnswerType: '',
      cardType: 'assignment',
      code: '',
      selectAns: '',
      selectAnsMulti: [],
      soundObject: {},
      userTemplateData: [],
      nextAction: [],
      TrueAns: '',
      mode: {},
      ShowAnswerModal: false,
      ModalData: {
        title: '',
        color: '',
        data: '',
      },
      data: [],
      answer: [],
      template: '',
      exceptionPath: [
        'IAM05-46',
        'IAM05-47',
        'IAM05-48',
        'IAM05-89',
        'IAM05-90',
        'IAM05-131',
        'IAM05-132',
        'IAM05-133',
        'IAM05-134',
        'IAM05-135',
        'IAM05-178',
        'IAM05-179',
        'IAM05-245',
        'IAM05-335',
        'IAM05-336',
        'IAM05-337',
        'IAM05-338',
        'IAM05-339',
        'IAM05-340',
        'IAM05-341',
        'IAM05-342',
      ],

      check: 0,
      i: 0,
      courseSection: '',
      startTime: '',
      condition: {},
      loading: false,
      isDone: false,
      newPath: '',
      mainUrl: [],
      nextRoute: '',
      userAnswerStatus: false,
      v3Score: 0,
      v3Data: {},
      nextPath: null,
    };
  },

  computed: {
    ...mapGetters({
      getCheckAnswerResult: 'template/getCheckAnswerResult',
      getMode: 'necessary/getMode',
      getTemplatev3: 'v3/getTemplates',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
    }),
  },

  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      const template = val.templates[0];
      this.content = template;
      this.nextRoute = template.navigate.next.action;

      if (!template.enable) {
        const pathFormat = template.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v4/${pathFormat[0]}/${pathFormat[1]}`);
      }

      //check
      this.check += 1;
      //check type
      this.checkType();
      //course sec
      this.courseSection =
        this.$store.getters['necessary/getUserCourseSection'];
      //sound
      this.soundObject = new Audio(
        this.baseUrl + template.content.question[0].item[0].item.data
      );
      this.data = Array(
        template.content?.question?.[0]?.item?.[0]?.item?.comment?.length
      );

      this.answer = template.content.question[0].choices;
      this.check = 0;

      this.$store.dispatch('v4/checkCurrentMainCode', this.v3Data);

      this.loading = false;
    },
    saveContentStatusv4: function (val) {
      // console.log(val, 'IAM05 Watcher Call');
      if (this.nextPath) {
        this.loading = true;

        const splitPath = this.nextPath.split('-');
        const onNext = `/v4/${splitPath[0]}/${splitPath[1]}`;
        //to LTK 01
        this.$router.push(onNext);
      }
    },
    data: function (val) {
      var checkMulti = this.content.content.question[0].multiSelect;

      if (checkMulti) {
        for (let i = 0; i < val.length; i++) {
          if (i === 0) {
            this.selectAns = val[i];
          } else if (i > 0) {
            if (val[i] !== undefined) {
              this.selectAns = this.selectAns + val[i];
            }
          }
        }
      } else {
        this.selectAns = val;
      }
    },
    '$route.params.id'() {
      // console.log('params change triggered', val);

      this.onLoad();
    },
  },

  mounted() {
    this.onLoad();
  },

  created() {
    this.isShow = false;
    this.check = 0;
  },

  beforeDestroy() {},
  methods: {
    onLoad() {
      this.loading = true;
      this.courseCode = this.$store.state.necessary.learningCourse;
      this.lang = this.$store.state.language.language;
      this.startTime = this.$helpers.getDateFormat();

      const contentId = `IAM05-` + this.$route.params.id;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
    },
    selectedAns(data) {
      var checkMulti = this.content.content.question[0].multiSelect;
      if (checkMulti == true) {
        let final = '';
        if (data.length > 0) {
          data.forEach((item, index) => {
            final += item;
          });
        }
        this.selectAns = final;
      } else {
        this.selectAns = data;
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    checkType() {
      const answerType = this.content?.content?.question[0]?.item[0]?.type;
      if (answerType == 3) {
        this.AnswerType = 'text';
      } else if (answerType == 2) {
        this.AnswerType = 'audio';
      } else if (answerType == 1) {
        this.AnswerType = 'image';
      }

      const type = this.content?.content?.question[0]?.item[0]?.item?.type;
      if (type == 3) {
        this.Type = 'text';
      } else if (type == 2) {
        this.Type = 'audio';
      } else if (type == 1) {
        this.Type = 'image';
      }
    },
    popupData2(x, code) {
      this.popUpIntroData = x;
      this.code = code;
      this.isShow = false;
      this.isShowPopupIntro = true;
    },
    setIsNextButtonActive(status) {
      this.isNextButtonActive = status;
    },
    getNextButtonColor(status) {
      if (status) return 'containerIconRight-matrix active';
      else return 'containerIconRight-matrix';
    },
    beforeSet() {
      if (this.selectAns && Object.keys(this.selectAns).length > 0) {
        this.loading = true;
        this.setData();
      } else {
        alert('Please complete exercise');
      }
    },
    setData() {
      let audio = this.soundObject;
      if (this.soundObject) {
        audio.pause();
      }
      var path = this.content.navigate.next.action;
      let str = path.split('-');
      this.mainUrl = str;
      this.nextAction = `/v4/${str[0]}/${str[1]}`;

      this.TrueAns =
        this.content?.content?.question[0]?.choices[0]?.choice?.choices?.item?.comment;

      let test = [];
      if (this.condition && Object.keys(this.condition).length > 0) {
        test.push(this.condition);
      }

      this.loading = false;

      //check answer
      this.checkAnswerResult();
    },
    funcRoute(tempId) {
      if (tempId === 'PreTest') {
        alert('You cannot exit while doing pretests.');
      } else {
        const previousAction = this.content.navigate.previous.action;
        const prevSplit = previousAction.split('-');
        const prevPath = `/v4/${prevSplit[0]}/${prevSplit[1]}`;
        let checkUrl = prevSplit[0];
        if (checkUrl === 'IAM05') {
          //fetch content IAM05
          const contentId = `IAM05-` + prevSplit[1];
          this.$store.dispatch('v3/fetchTemplateByCode', contentId);
        }
        this.$router.push(prevPath);
      }
    },
    ModalRoute() {
      const path = this.nextRoute;

      this.commitPayloadData(path);
      //clear v3 score
      this.v3Score = 0;
      this.ShowAnswerModal = false;
    },
    checkAnswerResult() {
      //val is state.result?
      let templateCode = `IAM05-` + this.$route.params.id;
      let except = this.exceptionPath.filter((i) => {
        if (templateCode == i) {
          return i;
        }
      });

      //val?
      //test setting ? maybe
      if (except.length == 0) {
        let isPreTest = preTestTemplate.filter((i) => {
          if (templateCode == i) {
            return i;
          }
        });
        let isTest = testTemplate.filter((i) => {
          if (templateCode == i) {
            return i;
          }
        });

        const correctAnswer =
          this.$store.state.v3.templates.correctAnswers.correctAnswers[0]
            .answer;
        const userAnswer = this.selectAns;
        //what if answer is multi as array ?????

        if (isPreTest.length > 0 || isTest.length > 0) {
          if (correctAnswer === userAnswer) {
            this.userAnswerStatus = true;
            this.v3Score = 1;
          } else {
            this.userAnswerStatus = false;
          }
          this.ModalRoute();
        } else {
          //check if string single answer only
          //need make for multi answer
          if (typeof userAnswer === 'string') {
            //assign status
            if (correctAnswer === userAnswer) {
              this.userAnswerStatus = true;
              this.v3Score = 1;
            } else {
              this.userAnswerStatus = false;
            }
            //modal
            if (this.userAnswerStatus) {
              this.ModalData = {
                title: 'Result',
                color: 'success',
                data: 'Correct #' + correctAnswer,
              };
              this.ShowAnswerModal = true;
            } else {
              if (isPreTest.length == 0) {
                this.ModalData = {
                  title: 'Result',
                  color: 'danger',
                  data: 'Incorrect. the correct answer is #' + correctAnswer,
                };
              } else {
                this.ModalData = {
                  title: 'Result',
                  color: 'danger',
                  data: 'Incorrect',
                };
              }

              this.loading = false;
              this.ShowAnswerModal = true;
            }
          } else {
            console.log('userAnswer type error');
          }
        }
      } else {
        //for except path
        //need to fix
        // console.log('else route');

        const correctAnswer =
          this.$store.state.v3.templates.correctAnswers.correctAnswers[0]
            .answer;
        const userAnswer = this.selectAns;
        //chcek answer and setscore
        const nextTo = this.content.navigate.next.action;

        let now = `IAM05-` + this.$route.params.id;
        let next = this.nextAction;
        let split_next = next.split('/');

        if (split_next[3] == 'IAM05') {
          if (correctAnswer === userAnswer) {
            this.userAnswerStatus = true;
            this.v3Score = 1;
          } else {
            this.userAnswerStatus = false;
          }

          let body = {};
          body.code = this.courseCode;
          body.templateCode = `IAM05-` + this.$route.params.id;

          if (
            now !== 'IAM05-134' ||
            now !== 'IAM05-338' ||
            now !== 'IAM05-342'
          ) {
            location.reload();
          }
        } else if (
          this.nextAction == '/v4/LKT01/65' ||
          this.nextAction == '/v4/LKT01/66'
        ) {
          if (correctAnswer === userAnswer) {
            this.userAnswerStatus = true;
            this.v3Score = 1;
          } else {
            this.userAnswerStatus = false;
          }

          this.commitPayloadData(nextTo);
        } else {
          if (correctAnswer === userAnswer) {
            this.userAnswerStatus = true;
            this.v3Score = 1;
            this.$store.commit('v3/v3CheckingResultTrue');
          } else {
            this.userAnswerStatus = false;
            this.$store.commit('v3/v3CheckingResultFalse');
          }
          this.commitPayloadData(nextTo);
        }
      }
    },
    commitPayloadData(path) {
      //for v4 planned ?
      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
        score: this.v3Score,
        maxScore: 1,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const currentDataStack = [...this.$store.state.v4.v4DataStack];
      const currentCodeItem = this.v3Data.codeItem;
      //get last code item form backend
      const lastCodeItem = this.v3Data.lastContent;
      //check store
      if (currentDataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
            mainCodeItem: this.v3Data.mainCodeItem,
            mainType: this.v3Data.mainType,
            mainContent: this.v3Data.mainContent,
            dataStack: currentDataStack,
            pages: this.v3Data.pages,
            courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
            section: this.$store.state.v3.v3EnrollData.data.section,
          });
          this.nextPath = path;
        } else {
          //onNext
          const str = path.split('-');
          const nextPath = `/v4/${str[0]}/${str[1]}`;
          this.$router.push(nextPath);
        }
        //if not just clear stack
      }
    },
  },
};
</script>
<style></style>
